import React, { useEffect, useState, Suspense } from 'react';
import SalesResumen from '../components/SalesResumen';
import PageHeader from '../components/ui/PageHeader';
import HeaderUtilities from '../components/ui/HeaderUtilities';
import './SalesResumenPage.css';

// Lazy A PROPÓSITO (perf, 21-sep-2026): TrendsPage es el OTRO importador de
// recharts (~150 kB gzip en el initial junto con AssistantChat). El tab
// Tendencias ya se renderiza condicional — su chunk se carga recién al abrirlo.
const TrendsPage = React.lazy(() => import('./TrendsPage'));

// Tab "Tendencias" (las gemelas de la auditoría, 2026-07-21): Tendencias era el
// mismo modelo (ventas agregadas) y la misma pregunta que Resumen con otro lente.
// Vive aquí como tab hermana SIN renombrar Resumen (decisión: cero re-aprendizaje
// de la página default de Isa). El tab es solo admin/coordinador — la vendedora
// ve Resumen sin tira de tabs, idéntico a siempre (Tendencias nunca fue suya).
// F5: encabezado al molde (PageHeader + ModuleTabs). La cápsula Actualizar·Exportar
// del Resumen sube vía registerControls (motor y números intactos).
export default function SalesResumenPage({ onReady, userRole, navTab = null, onNavigate }) {
  const canTrends = userRole === 'admin' || userRole === 'coordinador';
  const [activeTab, setActiveTab] = useState('resumen'); // 'resumen' | 'trends'
  const [controls, setControls] = useState(null); // Resumen registra su cápsula
  const [exportOpen, setExportOpen] = useState(false); // menú Por pedido / Por producto

  // Navegación con destino de pestaña (Hunter / mapeo legacy de 'trends').
  useEffect(() => {
    if (navTab?.tab && ['resumen', 'trends'].includes(navTab.tab)) setActiveTab(navTab.tab);
  }, [navTab]);

  const tab = canTrends ? activeTab : 'resumen';

  return (
    <div className="sales-resumen-page mobile-safe page-shell">
      <PageHeader
        title="Resumen de ventas"
        description="Ventas del período por canal, con pagos y productos."
        tabs={canTrends ? {
          tabs: [
            { id: 'resumen', label: 'Resumen' },
            { id: 'trends', label: 'Tendencias' },
          ],
          active: tab,
          onChange: setActiveTab,
        } : null}
        utilities={tab === 'resumen' ? (
          <HeaderUtilities
            onRefresh={() => controls?.onRefresh?.()}
            refreshing={!!controls?.refreshing}
            onExport={controls?.canExport ? () => setExportOpen((v) => !v) : null}
            exportDisabled={!controls?.canExport}
            exportMenu={exportOpen ? (
              <div className="export-menu">
                <button onClick={() => { controls?.onExportByOrder?.(); setExportOpen(false); }}>Por pedido</button>
                <button onClick={() => { controls?.onExportByProduct?.(); setExportOpen(false); }}>Por producto</button>
              </div>
            ) : null}
          />
        ) : null}
      />
      {tab === 'trends' ? (
        <Suspense fallback={null}><TrendsPage embedded /></Suspense>
      ) : (
        <SalesResumen onReady={onReady} userRole={userRole} registerControls={setControls} onNavigate={onNavigate} />
      )}
    </div>
  );
}
